module.exports = __webpack_public_path__ + "static/img/bouncetripleberry_th.7cf7286.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mixology/cans/bouncetripleberry_th.png
// module id = s9sN
// module chunks = 0